export default function convertToLocaleString(date: Date | string) {
  return new Date(date).toLocaleString('us-us', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
}
